import { useState, useEffect, useRef } from "react"
import { caseService } from '../../../services/caseService';
import { notify } from '../../../assets/helpers/toast';
import { useParams } from "react-router-dom";
import { useJsApiLoader } from '@react-google-maps/api';
import { FollowingMap } from "./FollowingMap"
import logo from '../../../images/logoFollowing.svg';
import phoneFollowing from '../../../images/phoneFollowing.svg';
import whatsappFollowing from '../../../images/whatsappFollowing.svg';
import persona from "../../../images/persona.svg"
import casa from "../../../images/casa.svg"
import towFollowing from '../../../images/towFollowing.svg';
import bikeFollowing from '../../../images/bikeFollowing.svg';
import { capitalize, calculateMiddlePoint } from "../../../assets/helpers/funciones";
import { enumStatus, OPERATIONS_PHONE } from "../../../assets/helpers/options.js"
import { useHistory } from "react-router-dom";
import { LoadSpinner } from "../../common/LoadSpinner/LoadSpinner.jsx";
import elipse from '../../../images/elipse.svg';
import facebookWhite from '../../../images/facebookWhite.svg';
import instagramWhite from '../../../images/instagramWhite.svg';
import twitterWhite from '../../../images/twitterWhite.svg';
import { GOOGLE_MAPS_LIBRARIES } from "../../common/Maps/googleMapsConfig";

const { AV_ASSIGNED, AV_ON_ROAD, AV_IN_ORIGIN, CANCELED, TOW_ASSIGNED, TOW_ON_ROAD, TOW_IN_ORIGIN, CUSTOMER_ON_ROAD, FINISHED,
} = enumStatus

const networks = [
    { src: facebookWhite, alt: "facebookWhite", url: "https://www.facebook.com/p/Tu-Gruero-100066840556940/" },
    { src: instagramWhite, alt: "instagramWhite", url: "https://www.instagram.com/tugruero/?hl=en" },
    { src: twitterWhite, alt: "twitterWhite", url: "https://x.com/tugruero" },
]


// --- Control de consumo de Google Directions / polling ---
const POLL_BASE_MS = 10 * 1000;          // frecuencia normal del GET al backend
const POLL_IDLE_MS = 30 * 1000;          // frecuencia cuando el chofer esta quieto
const IDLE_TICKS_BEFORE_SLOWDOWN = 3;    // ticks sin movimiento antes de espaciar
const SESSION_MAX_MS = 90 * 60 * 1000;   // tope sin cambio de status
const ROUTE_MAX_AGE_MS = 2 * 60 * 1000;  // techo para refrescar el ETA con trafico
const DEVIATION_THRESHOLD_M = 200;       // desvio de la polilinea que fuerza recalculo
const SAME_POINT_M = 20;                 // dos puntos a menos de esto se consideran iguales

const toMeters = (p, ref) => {
    const cos = Math.cos((ref.lat * Math.PI) / 180);
    return { x: (p.lng - ref.lng) * cos * 111320, y: (p.lat - ref.lat) * 110540 };
};

const distanceMeters = (a, b) => {
    const m = toMeters(b, a);
    return Math.hypot(m.x, m.y);
};

// Distancia del punto a la polilinea y metros que le faltan por recorrer sobre ella.
const analyzePath = (point, path) => {
    if (!path || path.length < 2) return null;
    const pts = path.map((p) => ({ lat: p.lat(), lng: p.lng() }));
    let best = { dist: Infinity, index: 0, t: 0 };
    for (let i = 0; i < pts.length - 1; i++) {
        const a = toMeters(pts[i], point);
        const b = toMeters(pts[i + 1], point);
        const dx = b.x - a.x;
        const dy = b.y - a.y;
        const len2 = dx * dx + dy * dy;
        const t = len2 === 0 ? 0 : Math.max(0, Math.min(1, -(a.x * dx + a.y * dy) / len2));
        const dist = Math.hypot(a.x + t * dx, a.y + t * dy);
        if (dist < best.dist) best = { dist, index: i, t };
    }
    let remaining = (1 - best.t) * distanceMeters(pts[best.index], pts[best.index + 1]);
    for (let i = best.index + 1; i < pts.length - 1; i++) {
        remaining += distanceMeters(pts[i], pts[i + 1]);
    }
    return { deviation: best.dist, remaining };
};

export const FollowingLink = () => {

    const history = useHistory();

    // Estado del control de consumo (refs: no deben provocar renders)
    const route1Ref = useRef(null);          // { dest, status, at, path, totalM, durationS }
    const route1InFlightRef = useRef(false);
    const route2KeyRef = useRef(null);       // ruta cliente->destino final: una sola vez
    const route2InFlightRef = useRef(false);
    const statusRef = useRef(null);
    const statusChangedAtRef = useRef(Date.now());
    const lastPosRef = useRef(null);
    const idleTicksRef = useRef(0);
    const [expired, setExpired] = useState(false);

    const intervalRef = useRef(null);
    const [following, setFollowing] = useState("");
    const [isLoading, setIsLoading] = useState(true);
    const [origin, setOrigin] = useState({});
    const [destiny, setDestiny] = useState({});
    const [finalDestiny, setFinalDestiny] = useState({});
    const [displayMessage, setDisplayMessage] = useState(false);
    const [directionsResponse, setDirectionsResponse] = useState(null);
    const [directionsResponse2, setDirectionsResponse2] = useState(null);
    const [route, setRoute] = useState({
        distance: '',
        time: '',
    });
    const [route2, setRoute2] = useState({
        distance: '',
        time: '',
    });

    const { caseId } = useParams();
    const { isLoaded } = useJsApiLoader({
        googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
        libraries: GOOGLE_MAPS_LIBRARIES,
    });

    const getCaseById = () => {
        return caseService
            .getTowLocation(caseId)
            .then((response) => {
                if (response.status === 200) {
                    setDisplayMessage(false);
                    setFollowing(response?.data);

                    // Control de consumo: cambio de status y movimiento del chofer
                    const currentStatus = response?.data?.case?.status;
                    if (currentStatus !== statusRef.current) {
                        statusRef.current = currentStatus;
                        statusChangedAtRef.current = Date.now();
                    }
                    const mobile = {
                        lat: parseFloat(response?.data?.locationMobile?.lat),
                        lng: parseFloat(response?.data?.locationMobile?.lon),
                    };
                    if (Number.isFinite(mobile.lat) && Number.isFinite(mobile.lng)) {
                        const moved = !lastPosRef.current || distanceMeters(lastPosRef.current, mobile) > SAME_POINT_M;
                        idleTicksRef.current = moved ? 0 : idleTicksRef.current + 1;
                        if (moved) lastPosRef.current = mobile;
                    }


                    if ([AV_ASSIGNED, AV_ON_ROAD, AV_IN_ORIGIN,]?.includes(response?.data?.case?.status)) {
                        // Bike
                        let origin = {
                            lat: parseFloat(response?.data?.locationMobile?.lat),
                            lng: parseFloat(response?.data?.locationMobile?.lon),
                            location: capitalize(response?.data?.locationMobile?.location),
                            icon: bikeFollowing
                        }
                        // Client
                        let destiny = {
                            lat: parseFloat(response?.data?.case?.originLatitude),
                            lng: parseFloat(response?.data?.case?.originLongitude),
                            location: capitalize(response?.data?.case?.originAddress),
                            icon: persona
                        }

                        if (!response?.data?.case?.originLatitude) {
                            notify(`originLatitude missing`, 'info');
                        }

                        if (!response?.data?.case?.originLongitude) {
                            notify(`originLongitude missing`, 'info');
                        }

                        setOrigin(origin);
                        setDestiny(destiny);
                        calculateRoute(origin, destiny)
                    }

                    if ([TOW_ASSIGNED, TOW_ON_ROAD, TOW_IN_ORIGIN]?.includes(response?.data?.case?.status)) {
                        // Tow
                        let origin = {
                            lat: parseFloat(response?.data?.locationMobile?.lat),
                            lng: parseFloat(response?.data?.locationMobile?.lon),
                            location: capitalize(response?.data?.locationMobile?.location),
                            icon: towFollowing
                        }
                        // Client
                        let destiny = {
                            lat: parseFloat(response?.data?.case?.originLatitude),
                            lng: parseFloat(response?.data?.case?.originLongitude),
                            location: capitalize(response?.data?.case?.originAddress),
                            icon: persona
                        }

                        let finalDestiny = {
                            lat: parseFloat(response?.data?.case?.destinyLatitude),
                            lng: parseFloat(response?.data?.case?.destinyLongitude),
                            location: capitalize(response?.data?.case?.destinyAddress),
                            icon: casa
                        }


                        setOrigin(origin);
                        setDestiny(destiny);
                        setFinalDestiny(finalDestiny);
                        calculateRoute(origin, destiny)
                        calculateRoute2(destiny, finalDestiny)
                    }

                    if ([CUSTOMER_ON_ROAD]?.includes(response?.data?.case?.status)) {
                        // Tow
                        let origin = {
                            lat: parseFloat(response?.data?.locationMobile?.lat),
                            lng: parseFloat(response?.data?.locationMobile?.lon),
                            location: capitalize(response?.data?.locationMobile?.location),
                            icon: towFollowing
                        }
                        // Client
                        let destiny = {
                            lat: parseFloat(response?.data?.case?.destinyLatitude),
                            lng: parseFloat(response?.data?.case?.destinyLongitude),
                            location: capitalize(response?.data?.case?.destinyAddress),
                            icon: casa
                        }
                        setOrigin(origin);
                        setDestiny(destiny);
                        calculateRoute(origin, destiny)
                    }



                    if ([CANCELED]?.includes(response?.data?.status)) {
                        history.push(`/following-link/${caseId}/canceled`)
                    }

                    if ([FINISHED]?.includes(response?.data?.status)) {
                        history.push(`/following-link/${caseId}/finished`)
                    }


                    if (!response?.data?.locationMobile?.lat || !response?.data?.locationMobile?.lon) {
                        setDisplayMessage(true);
                        console.log(`locationMobile missing`, 'info');
                    }

                    setIsLoading(false);
                    return
                }

                if (response.status === 400) {
                    if (response?.data?.message === 'Provider is external') {
                        history.push(`/following-link/${caseId}/external`)
                    }
                    return
                }

                else {
                    notify(`${response.message}`, 'error');
                }
            })
            .catch(() => { });
    };


    const isValidPoint = (p) => Number.isFinite(p?.lat) && Number.isFinite(p?.lng);

    const requestRoute = async (origin, destiny) => {
        const directionsService = new window.google.maps.DirectionsService();
        return directionsService.route({
            origin: new window.google.maps.LatLng(origin?.lat, origin?.lng),
            destination: new window.google.maps.LatLng(destiny?.lat, destiny?.lng),
            travelMode: window.google.maps.TravelMode.DRIVING,
        });
    };

    // Ruta chofer -> destino. Solo llama a Directions si hace falta; si no, solo
    // actualiza el ETA localmente con lo que le falta por recorrer de la polilinea.
    async function calculateRoute(origin, destiny) {
        if (!isValidPoint(origin) || !isValidPoint(destiny)) {
            return;
        }
        if (!window.google?.maps?.DirectionsService) {
            return; // el script de Maps aun no carga; se reintenta en el siguiente tick
        }

        const status = statusRef.current;
        const last = route1Ref.current;
        const analysis = last?.path?.length ? analyzePath(origin, last.path) : null;

        const needsNewRoute =
            !last ||
            last.status !== status ||
            distanceMeters(last.dest, destiny) > SAME_POINT_M ||
            Date.now() - last.at > ROUTE_MAX_AGE_MS ||
            (analysis && analysis.deviation > DEVIATION_THRESHOLD_M);

        if (!needsNewRoute) {
            // ETA local: proporcional a lo que falta por recorrer de la ruta ya trazada
            if (analysis && last.totalM > 0) {
                const ratio = Math.min(1, analysis.remaining / last.totalM);
                setRoute({
                    time: ((last.durationS * ratio) / 60).toFixed(),
                    distance: ((analysis.remaining) / 1000).toFixed(2),
                });
            }
            return;
        }

        if (route1InFlightRef.current) {
            return;
        }
        route1InFlightRef.current = true;
        try {
            const results = await requestRoute(origin, destiny);
            const leg = results.routes[0].legs[0];
            route1Ref.current = {
                dest: { lat: destiny.lat, lng: destiny.lng },
                status,
                at: Date.now(),
                path: results.routes[0].overview_path || [],
                totalM: leg.distance.value,
                durationS: leg.duration.value,
            };
            setDirectionsResponse(results);
            setRoute({
                time: (leg.duration.value / 60).toFixed(),
                distance: (leg.distance.value / 1000).toFixed(2),
            });
        } catch (e) {
            // Marca el intento para no reintentar en cada tick (se reintenta pasado ROUTE_MAX_AGE_MS)
            route1Ref.current = {
                dest: { lat: destiny.lat, lng: destiny.lng },
                status,
                at: Date.now(),
                path: [],
                totalM: 0,
                durationS: 0,
            };
        } finally {
            route1InFlightRef.current = false;
        }
    }

    // Ruta cliente -> destino final: es estatica, se pide una sola vez por par de puntos.
    async function calculateRoute2(origin, destiny) {
        if (!isValidPoint(origin) || !isValidPoint(destiny)) {
            return;
        }
        if (!window.google?.maps?.DirectionsService) {
            return;
        }
        const key = `${origin.lat},${origin.lng}->${destiny.lat},${destiny.lng}`;
        if (route2KeyRef.current === key || route2InFlightRef.current) {
            return;
        }
        route2InFlightRef.current = true;
        try {
            const results = await requestRoute(origin, destiny);
            route2KeyRef.current = key;
            setDirectionsResponse2(results);
            setRoute2({
                time: (results.routes[0].legs[0].duration.value / 60).toFixed(),
                distance: (results.routes[0].legs[0].distance.value / 1000).toFixed(2),
            });
        } catch (e) {
            route2KeyRef.current = key; // no reintentar en bucle una ruta que falla
        } finally {
            route2InFlightRef.current = false;
        }
    }

    // Polling: pausa con la pestana oculta, se espacia si el chofer esta quieto
    // y se detiene tras SESSION_MAX_MS sin cambio de status.
    useEffect(() => {
        let timer = null;
        let stopped = false;
        let running = false; // evita dos cadenas de polling si visibilitychange llega con un GET en curso

        const schedule = () => {
            if (stopped) return;
            const delay = idleTicksRef.current >= IDLE_TICKS_BEFORE_SLOWDOWN ? POLL_IDLE_MS : POLL_BASE_MS;
            timer = setTimeout(tick, delay);
        };

        const tick = async () => {
            if (stopped || running) return;
            if (Date.now() - statusChangedAtRef.current > SESSION_MAX_MS) {
                stopped = true;
                setExpired(true);
                return;
            }
            if (document.visibilityState === "hidden") {
                return; // se reanuda en visibilitychange
            }
            running = true;
            try {
                await getCaseById();
            } finally {
                running = false;
            }
            schedule();
        };

        const onVisibilityChange = () => {
            if (document.visibilityState === "visible" && !stopped) {
                clearTimeout(timer);
                tick();
            }
        };

        document.addEventListener("visibilitychange", onVisibilityChange);
        tick();

        return () => {
            stopped = true;
            clearTimeout(timer);
            document.removeEventListener("visibilitychange", onVisibilityChange);
        };
    }, []);

    if (!isLoaded) {
        return null;
    }


    return (
        <div style={{ minHeight: "100vh" }} >
            <LoadSpinner show={isLoading} />
            <FollowingLinkHeader />
            {expired && (
                <div style={{ textAlign: "center", padding: "12px 20px" }}>
                    <p>El seguimiento se pausó por inactividad.</p>
                    <button type="button" onClick={() => window.location.reload()}>Actualizar</button>
                </div>
            )}
            {displayMessage ? <MessageFollowing /> :
                <>
                    <FollowingMap data={[origin, destiny, finalDestiny]} middlePoint={calculateMiddlePoint([origin, destiny])} directionsResponse={directionsResponse} directionsResponse2={directionsResponse2} />
                    <FollowingLinkFooter data={following} route={route} />
                </>
            }
        </div>
    )
}

export const FollowingLinkHeader = () => {
    return (
        <div className="following-link-header">
            <img src={logo} alt="" />
        </div>
    )
}

export const FollowingLinkFooter = (props) => {
    const { data, route } = props
    const providePhone = data?.provider?.phone ? data?.provider?.phone.replace(/-/g, '').replace(/^0/, '') : null
    return (
        <div className="following-link-footer">
            <div className="following-link-footer-banner" ><h4>Información del Gruero</h4></div>
            <div className="following-link-footer-provider-info-container" >

                <div className="following-link-footer-provider-info">
                    <div>
                        <h6 style={{ color: "white" }}>
                            {data?.provider?.name}
                        </h6>
                        <p>{data?.provider?.type}</p>
                    </div>
                    <div>
                        <a href={`tel:+58${providePhone}`}>
                            <img src={phoneFollowing} alt="phoneFollowing" />
                        </a>
                        <a href={`whatsapp://send?phone=+58${providePhone}&text=Hola, tengo un servicio activo y tengo la siguiente duda: !`}>
                            <img src={whatsappFollowing} alt="whatsappFollowing" />
                        </a>
                    </div>
                </div>

            </div>
            <div className="following-link-footer-vehicle-info">
                <div>
                    <h6>Placa de la {data?.provider?.type === 'Asistente Vial' ? "Moto" : "Grua"}:</h6>
                    <b>{data?.vehicle?.plate}</b>
                </div>
                <div>

                    {[CUSTOMER_ON_ROAD].includes(data.status) ? <h6>Llegarás a tu destino en</h6> : <h6>Llegando a buscarte en</h6>}

                    <b>{route?.time} Minutos</b>
                </div >
                <p style={{ marginTop: "12px", fontSize: "10px", textAlign: "center" }}>La ruta mostrada es referencial, el conductor podría tomar otra vía más óptima</p>
            </div >
        </div >
    )
}

export const MessageFollowing = () => {
    return (
        <div className="message-following-component">
            <span style={{ marginTop: "46px" }}></span>
            <div style={{ alignItems: "center", justifyContent: "center" }} className="following-message-body">
                <p style={{ textAlign: "center", padding: "0 20px", lineHeight: 1.6 }}>
                    Mapa no disponible
                    <br />
                    ¡Estamos trabajando para ti, disculpa las molestias ocasionadas!
                </p>
            </div>

            <div className="message-following-social-networks">
                <div>
                    {networks.map((n, index) => (
                        <a key={n.alt} href={n.url} target="_blank" >
                            <img src={n.src} alt="facebookWhite" />
                        </a>
                    ))}
                </div>
                <div>Siguenos en nuestras redes</div>
            </div>


            <img className="elipse" src={elipse} alt="elipse" />
        </div>

    )
}